__webpack_require__.hmrF = () => ("communities." + __webpack_require__.h() + ".hot-update.json");